var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-item",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"icon"},[_vm._t("default")],2),_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }